import {ParsedUrlQuery} from 'querystring';
import {convertQueryInputToSingleElement} from '../../common/shared/utils/convertQueryInputToSingleElement';

export function getRankingThemeParamFromQuery({
  query,
}: {
  uidInfoList: string[];
  query?: ParsedUrlQuery;
}) {
  const filterType = convertQueryInputToSingleElement(
    query?.ranking_filter_type
  );
  const sortType = convertQueryInputToSingleElement(query?.sort_type);

  return {
    filterType,
    sortType,
  };
}
